<template>
    <div :class="'w-' + size + ' h-' + size" class="relative">
        <IconSettings 
            :classes="'w-' + size + ' h-' + size + ' ' + classes" />
        <div v-if="canUse('personal-auspiciousness') && ! user.birth || user.subscription.status == 'PastDue'" class="absolute top-0 right-0 text-prime-500 text-xs -mt-1">●</div>
    </div>
</template>

<script>
import IconSettings from '@/components/visual/icons/IconSettings'
import { mapState, mapGetters } from 'vuex'
export default {
    props: [ 'size', 'classes' ],
    components: { IconSettings },
    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('auth', ['canUse']),
    }
}
</script>
